"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getLazyImageUtilityClass = getLazyImageUtilityClass;
var _base = require("@ori-ui/mui-bundle/base");
function getLazyImageUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('MuiOriLazyImage', slot);
}
const lazyImageClasses = (0, _base.generateUtilityClasses)('MuiOriLazyImage', ['root', 'skeleton', 'image']);
var _default = exports.default = lazyImageClasses;
